export const checkDescription = (description?: string) => {
  if (!description || description === '<p><br></p>') return;
  return description;
};
